import Modal from "../../shared/Modal";
import "./DeleteDocumentConfirmModal.css";
import { Button } from "../../../ds2/components";

type DeleteDocumentConfirmProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const DeleteDocumentConfirm = ({
  isOpen,
  onClose,
  onContinue,
}: DeleteDocumentConfirmProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-delete-document-confirm">
          <div className="modal-delete-document-confirm-title">
            Delete this Document
          </div>

          <div className="modal-delete-document-confirm-content">
            This document will be permanently deleted.
          </div>

          <div className="modal-delete-document-confirm-footer">
            <div className="modal-delete-document-confirm-buttons">
                <Button
                    variant="secondary"
                    onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={() => onContinue()}
                >
                    Delete
                </Button>
                
                {/* <button 
                    className="button-cancel"
                    onClick={onClose}
                >
                    Cancel
                </button>
                <button
                    className="button-save"
                    onClick={() => onContinue()}
                >
                    Delete
                </button> */}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeleteDocumentConfirm;
